import { UserService } from './../../../services/user.service';
var TakePhotoComponent = /** @class */ (function () {
    function TakePhotoComponent(_userService) {
        this._userService = _userService;
    }
    return TakePhotoComponent;
}());
export { TakePhotoComponent };
